import { useCallback, useMemo } from 'react';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import dayjs_timezone from 'dayjs/plugin/timezone';
import dayjs_utc from 'dayjs/plugin/utc';

dayjs.extend(isBetween);
dayjs.extend(dayjs_utc);
dayjs.extend(dayjs_timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export const useDayJs = () => {
  const timezone = 'Asia/Seoul';

  const newDayJs = useCallback(
    (date?: string | number | dayjs.Dayjs | Date | null | undefined) => {
      return dayjs(date).tz(timezone);
    },
    [timezone],
  );

  return newDayJs;
};
